import { INPUT_TYPE, BANK_NAMES } from "globalConstants";
import { ICommonFixture } from "types";

const fixture: ICommonFixture[] = [
    {
        name: "bankName",
        label: "Bank Name",
        inputType: INPUT_TYPE.SELECT,
        editable: true,
        defaultValue: "",
        placeholder: "Select Bank Name",
        options: BANK_NAMES.map((name) => name.name),
        showMask: true,
    },
    {
        name: "accountType",
        label: "Account Type",
        inputType: INPUT_TYPE.SELECT,
        editable: true,
        defaultValue: "",
        placeholder: "Select Account Type",
        options: ["Savings", "Current"],
    },
    {
        name: "accountNumber",
        label: "Account Number",
        inputType: INPUT_TYPE.TEXT,
        editable: true,
        defaultValue: "",
        placeholder: "Enter Account Number",
        showMask: true,
    },
];

export default fixture;
